<template>
  <div class="kChart" style="position: relative">
    <ul class="headerList">
      <div :class="{ leadList: stepList == 1 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">标的:</label>
          <p>
            <span class="titCen"
              >{{ getKsubject.symbol }}-{{ getKsubject.name }}</span
            >
            <el-button size="small" @click="symbolfun('symbol')"
              >更换标的</el-button
            >
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 1 && stepType <= newGuideIdx"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" />
          <h3 style="margin: -28px 0 0 -56px;">请选择标的</h3>
        </div>
      </div>
      <li>
        <label class="tit">时间:</label>
        <p>
          <span class="titCenData"
            >{{ headerData.startDate }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
              headerData.endDate
            }}</span
          >
        </p>
      </li>
      <div :class="{ leadList: stepList == 2 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">主图指标:</label>
          <p style="padding-left: 15px">
            <!--  v-for="(item,idx) in headerData.dataPropertyTOList" -->
            <span
              style="padding: 0px"
              class="titCen"
              v-for="(item, idx) in dataTOList"
              :key="idx"
              >{{
                dataTOList.length == idx + 1 ? item.code : item.code + ","
              }}&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
            <el-button
              size="small"
              @click="symbolfun('MASTER')"
              style="margin-left: 10px"
              >更换指标</el-button
            >
          </p>
          <el-popover placement="right" width="480" trigger="hover">
            <ul class="promptUl">
              <li style="margin-bottom: 10px">
                MA5:最近5天收市价格的算术平均线，
                <br />计算公式：MA5 =（C1+C2+C3+…+C5）/5，C：当日收盘价
                <br />
              </li>
              <li style="margin-bottom: 10px">
                MA10:最近10天收市价格的算术平均线，
                <br />计算公式：MA10 =（C1+C2+C3+…+C10）/10，C：当日收盘价
                <br />
              </li>
              <li style="margin-bottom: 10px">
                MA20:最近20天收市价格的算术平均线，
                <br />计算公式：MA20 =（C1+C2+C3+…+C20）/20，C：当日收盘价
                <br />
              </li>
              <li style="margin-bottom: 10px">
                MA60:最近60天收市价格的算术平均线，
                <br />计算公式：MA60 =（C1+C2+C3+…+C60）/60，C：当日收盘价
                <br />
              </li>
              <li style="margin-bottom: 10px">
                ema10:指数移动平均（EMA）：是以指数式递减加权的移动平均。各数值的加权影响力随时间而指数式递减，
                越近期的数据加权影响力越重，但较旧的数据也给予一定的加权值。
                加权的程度以常数α决定，α数值介乎0至1。
                α也可用窗口长度Length来代表： α = 2 / ([时间段数] + 1),
                确定10天EMA： （2 / [10 + 1]）= 0.1818或18.18％, 获得乘数后，
                您可以使用以下等式确定EMA： 乘数x（收盘价 - EMA [前一天]）+
                EMA（前一天）
                <br />
              </li>
              <li style="margin-bottom: 10px">
                ema20:指数移动平均（EMA）：是以指数式递减加权的移动平均。各数值的加权影响力随时间而指数式递减，越近期的数据加权影响力越重，
                但较旧的数据也给予一定的加权值。 加权的程度以常数α决定，
                α数值介乎0至1。α也可用窗口长度Length来代表： α = 2 / ([时间段数]
                + 1), 确定20天EMA： （2 / [20 + 1]）= 0.0952或9.52％,
                获得乘数后， 您可以使用以下等式确定EMA： 乘数x（收盘价 - EMA
                [前一天]）+ EMA（前一天）
                <br />
              </li>
            </ul>
            <i class="el-icon-question prompt" slot="reference"></i>
          </el-popover>
        </li>
        <div
          class="digBox"
          v-if="stepList == 2 && stepType <= newGuideIdx"
          style="right: -106px; top: 20px"
        >
          <img src="../../assets/image/lead1.png" />
          <h3 style="margin-left: -79px;">请选择主图指标</h3>
        </div>
      </div>
    </ul>
    <!-- k线图 -->
    <div
      class="box-card shadow"
      style="position: relative"
      v-if="initType"
      v-loading="loading"
    >
      <masterEchart
        :getData="getData"
        :startTime="startTime"
        @onZoomInit="echartInit"
        :endTime="endTime"
        :homeTitle="getKsubject.name"
        :getKlineData="getKlineList"
        :typeName="false"
        ref="kdata"
      ></masterEchart>
      <div class="cardBox" v-if="stepList == 3 && stepType <= newGuideIdx">
        <h3>向下划动滚轮可见更多往年值</h3>
        <p class="cardBox_p">
          <label class="cardBox_lab1">
            <label class="cardBox_lab2"></label>
          </label>
        </p>
      </div>
    </div>
    <!-- <candlestick :getData="getData" ref="kdata"></candlestick> -->
    <!-- 标的弹窗 -->
    <subject
      :headerData="headerData"
      ref="subject"
      @onSucceed="onSucceed"
      :symbolVisible="symbolType"
      :getKsubject="getKsubject"
    ></subject>
    <!-- 主图指标弹窗 -->
    <mastermap
      :headerData="headerData"
      ref="mastermap"
       titleVal="主图指标选择"
      @onMaster="onMaster"
      :mastermapVisible="masterType"
      :dataTOList="dataTOList"
    ></mastermap>
    <!-- 指引 -->
    <template v-if="stepType <= newGuideIdx">
      <div class="leadBox"></div>
      <!-- <div class="skip" @click="stepType='null'">跳过</div> -->
      <!-- <div class="nextStep">
        <template v-if="getKsubject.symbol && stepList == 1">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++">下一步</el-button>
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
        <template v-else-if="dataTOList.length > 0">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++">下一步</el-button>
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
      </div> -->
    </template>
  </div>
</template>
<script>
import TimeUtil from "@/util/TimeUtil.js";
import masterEchart from "@/views/factorAnalysis/common/echarts/masterEchart.vue";
import subject from "@/components/subjectDialog/subject.vue"; // 标的弹窗
import mastermap from "@/components/subjectDialog/mastermap.vue"; // 主图指标弹窗
export default {
  components: { subject, mastermap, masterEchart },
  data() {
    return {
      // 新手指引
      stepList: 1, // 步数
      stepType: 0, // 记录进入次数
      newGuideIdx: this.$store.state.newGuideIdx, // 限制次数
      initType: false,

      startTime: "0",
      endTime: "50",
      // 标的
      getKsubject: {},
      // 主图指标
      dataTOList: [], // 已选择数据
      masterType: false,
      // 获取k线对应指标,每次获取一个，操作方式为循环添加
      getKlineList: [],
      paramType: "0",
      symbolType: false,
      masterVisible: false,
      loading: false,
      headerData: {},
      getData: [],
      // K线图
      getKdataTo: {
        endDate: "", // 數據結束時間
        exchange: "", // 市場
        frequency: "day.1", // 频率: m.1, m.5, m.30, m.60, d.1, d.w, d.m day.month
        reinstatement: "na", // 复权,na,fward,bward
        startDate: "", // 數據開始時間
        symbol: "", // 标的
      },
      // 获取k线对应指标
      getKLinedata: {
        getKDataTO: {
          endDate: "",
          exchange: "",
          frequency: "day.1",
          reinstatement: "na",
          startDate: "",
          symbol: "",
        },
        indexName: "", // 指标名稱
      },
    };
  },
  methods: {
    // 完成
    onload() {
      // this.dataTOList = [];
      this.initType = true;
      this.stepType = "null";
      this.getIndexParam();
      //  this.getKData();
    },
    // 新手指引
    localGet() {
      if (JSON.parse(localStorage.getItem("mastermapIdx"))) {
        this.stepType = Number(localStorage.getItem("mastermapIdx"));
        const webSizeIdx = Number(localStorage.getItem("mastermapIdx")) + 1;
        localStorage.setItem("mastermapIdx", webSizeIdx);
      } else {
        localStorage.setItem("mastermapIdx", 1);
      }
    },
    echartInit(item) {
      this.startTime = item.start.toString();
      this.endTime = item.end.toString();
      this.$nextTick(() => {
        // this.$refs.picEchart[1].echartsInit();
        this.$refs.kdata.echartsInit();
      });
    },
    // 主图指标
    onMaster(item, type) {
      this.masterType = false;
      if (type) {
        this.loading = true;
        this.dataTOList = item;
         if(this.stepList==2){
              this.onload();
          }else{
// 初始化
        this.getKLineIndex();
          }
      }
    },
    // 标的保存
    onSucceed(item, type) {
      this.symbolType = false;
      if (type) {
        this.loading = true;
          if(this.stepList==1){
              this.stepList++
          }
        this.getKsubject = item;
        // 标的参数
        this.getKdataTo.exchange = item.exchange;
        this.getKdataTo.symbol = item.symbol;
        // 主图指标
        this.getKLinedata.getKDataTO.exchange = item.exchange;
        this.getKLinedata.getKDataTO.symbol = item.symbol;
        // 初始化
        this.getKLineIndex();

      }
    },
    // 弹窗
    symbolfun(type) {
      if (type == "MASTER") {
        // 更换指标
        this.masterType = true;
        // this.$refs.mastermap.iconAdd(this.dataTOList[0]); // 默认显示第一个
        this.$refs.mastermap.ngInitList();
        // this.$refs.mastermap.paramSelect(this.dataTOList[0]); // 默认显示第一个
      } else if (type == "symbol") {
        // 标的
        this.symbolType = true;
        this.$refs.subject.selectBtn(this.getKsubject); // 默认显示第一个
      }
      // this.getKLineIndex();
    },
    // 初始化参数
    getIndexParam() {
      this.$api.hubei.getIndexParam().then((res) => {
        if (res) {
          this.headerData = res;
          // this.getKsubject = res.codeDataTOList[0]; // 标的
          // this.dataTOList.push(res.dataPropertyTOList[0]); // 主图指标
          this.getKdataTo.endDate = res.endDate;
          this.getKdataTo.exchange = res.codeDataTOList[0].exchange;
          this.getKdataTo.symbol = res.codeDataTOList[0].symbol;
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00"; // res.startDate;
          // 指标名称
          this.getKLinedata.getKDataTO.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00"; //res.startDate;
          this.getKLinedata.getKDataTO.endDate = res.endDate;
          this.getKLinedata.getKDataTO.exchange =
            res.codeDataTOList[0].exchange;
          this.getKLinedata.getKDataTO.symbol = res.codeDataTOList[0].symbol;
          this.$nextTick(() => {
            this.$refs.subject.ngOnInit();
            this.$refs.mastermap.ngOnInit();
          });
          // 获取主图k线图
          this.getKLineIndex();
        }
      });
    },
    // 遍历获取k线对应指标
    async getKLineIndex() {
      // for dataTOList getKlineList
      this.getKlineList = [];
      for (const item of this.dataTOList) {
        this.getKLinedata.indexName = item.code;
        await this.$api.hubei.getKLineIndex(this.getKLinedata).then((res) => {
          this.getKlineList.push(res);
        });
      }
      // 获取主图
      this.getKData();
      // this.getKlineList =getKlineList;
    },
    // 获取主图
    getKData() {
      const than = this;
      this.loading = true;
      this.$api.hubei.getKData(this.getKdataTo).then((res) => {
        this.loading = false;
        than.getData = res.kDataTOList || [];
        if (this.initType) {
          this.$nextTick(() => {
            this.$refs.kdata.echartsInit();
          });
        }
      });
    },
  },
  created() {
    this.getIndexParam();
    // this.localGet();
    this.$ILab.StartStep("mastermap")
  },
};
</script>
<style lang="less" scoped>
.active {
  color: #fff;
  background: rgba(63, 152, 241, 1);
  border-radius: 4px;
  font-size: 14px;
}
.kChart {
  .headerList {
    li {
      font-size: 14px;
      color: #666666;
      margin-bottom: 20px;
      font-family: MicrosoftYaHei;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
      .tit {
        color: #3f98f1;
        width: 64px;
        line-height: 34px;
      }
      > span {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCenData {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCen {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        color: #333333;
        font-size: 14px;
      }
      // .titCen:hover {
      //   color: #fff;
      //   background: rgba(63, 152, 241, 1);
      //   border-radius: 4px;
      //   font-size: 14px;
      // }
    }
  }
}
.box-card {
  height: 600px;
}
// 弹窗
.symbolDialog {
  .tit {
    color: #3f98f1;
    display: inline-block;
    width: 64px;
    line-height: 34px;
  }
  .symbolDiaUl {
    li {
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
    }
  }
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  .shadow {
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  }
}

// 新手指引
.leadBox {
  margin-left: -16px;
  background: rgba(51, 51, 51, 0.3);
  position: fixed;
  width: 100%;
  top: 0;
  height: 100%;
  right: 0;
  bottom: 0;
}
.cardBox {
  position: absolute;
  left: 172px;
  z-index: 10;
  bottom: 84px;
  color: #fff;
  font-size: 24px;
}
.leadList {
  position: relative;
  z-index: 9;
  background: #ffffff;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  // pointer-events: none;
  .digBox {
    position: absolute;
    right: -225px;
    z-index: 10;
    top: 44px;
    color: #fff;
    font-size: 24px;
    h3 {
      margin-left: -119px;
    }
  }
}
.skip {
  position: absolute;
  right: 12%;
  top: 91px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.nextStep {
  position: absolute;
  font-size: 21px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  left: 500px;
  top: 30%;
}
.cardBox_p {
  width: 37px;
  height: 85px;
  background: #ffffff;
  border-radius: 33px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  padding-top: 14px;
  .cardBox_lab1 {
    width: 17px;
    height: 36px;
    border-radius: 9px;
    border: 1px solid #979797;
    display: block;
  }
  .cardBox_lab2 {
    width: 14px;
    height: 14px;
    background: #d8d8d8;
    display: block;
    border-radius: 100%;
  }
}
</style>
